"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const LoadingPlaceholder_1 = __importDefault(require("../LoadingPlaceholder"));
const validateSvg_1 = __importDefault(require("../../../shared/validateSvg"));
const valueIsString_1 = __importDefault(require("../../../typeAssertions/valueIsString"));
const valueIsImageStaticFileSource_1 = __importDefault(require("../../../typeAssertions/valueIsImageStaticFileSource"));
const ImageRenderer = ({ control, style, }) => {
    const [hasSrcError, setHasSrcError] = (0, react_1.useState)(false);
    const { Render, functions: { processor }, imageStaticSourcesByFileName, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const wrapperStyle = (0, react_1.useMemo)(() => {
        const hasBorderWith = style.borderTopWidth
            || style.borderBottomWidth
            || style.borderLeftWidth
            || style.borderRightWidth;
        const computedStyle = {
            marginBottom: style.marginBottom,
            marginLeft: style.marginLeft,
            marginRight: style.marginRight,
            marginTop: style.marginTop,
            borderTopLeftRadius: style.borderTopLeftRadius || 0.1,
            borderTopRightRadius: style.borderTopRightRadius || 0.1,
            borderBottomLeftRadius: style.borderBottomLeftRadius || 0.1,
            borderBottomRightRadius: style.borderBottomRightRadius || 0.1,
            borderTopWidth: style.borderTopWidth,
            borderBottomWidth: style.borderBottomWidth,
            borderRightWidth: style.borderRightWidth,
            borderLeftWidth: style.borderLeftWidth,
            borderColor: style.borderColor,
            width: style.width,
            height: style.height,
            borderWidth: hasBorderWith ? 0.01 : 0,
        };
        return computedStyle;
    }, [style]);
    const imageStyle = (0, react_1.useMemo)(() => ({
        width: '100%',
        height: '100%',
        borderTopLeftRadius: style.borderTopLeftRadius || 0.1,
        borderTopRightRadius: style.borderTopRightRadius || 0.1,
        borderBottomLeftRadius: style.borderBottomLeftRadius || 0.1,
        borderBottomRightRadius: style.borderBottomRightRadius || 0.1,
    }), [style]);
    (0, react_1.useEffect)(() => {
        const comprobate = async () => {
            if (control.src && !(0, valueIsImageStaticFileSource_1.default)(control.src)) {
                const isSvg = await (0, validateSvg_1.default)(control.src);
                if (isSvg) {
                    processor.root.updateControlById({
                        control,
                        dataToUpdate: {
                            sourceType: 'svg',
                        },
                    });
                }
                setHasSrcError(false);
            }
        };
        if (hasSrcError)
            comprobate();
    }, [control, control.src, hasSrcError, processor.root]);
    const renderedImage = (0, react_1.useMemo)(() => {
        if (control.sourceType === 'image') {
            let src;
            const defaultSource = {
                uri: 'https://via.placeholder.com/200x200',
            };
            if ((0, valueIsString_1.default)(control.src)) {
                src = {
                    uri: control.src,
                };
            }
            else if ((0, valueIsImageStaticFileSource_1.default)(control.src)) {
                src = imageStaticSourcesByFileName[control.src.fileName] || defaultSource;
            }
            else {
                src = defaultSource;
            }
            return (react_1.default.createElement(Render.Image, { resizeMode: control.resizeMode || 'cover', source: src, style: imageStyle, onError: () => setHasSrcError(true) }));
        }
        if (control.sourceType === 'lottie') {
            return (react_1.default.createElement(Render.Lottie, { src: control.src || undefined, visible: true }));
        }
        if (control.sourceType === 'svg') {
            return (react_1.default.createElement(Render.SvgImage, { src: control === null || control === void 0 ? void 0 : control.src }));
        }
        return null;
    }, [
        control.sourceType,
        control.resizeMode,
        control.src,
        Render,
        imageStyle,
        imageStaticSourcesByFileName,
    ]);
    return (react_1.default.createElement(LoadingPlaceholder_1.default, { control: control, style: style },
        events.onPress && (react_1.default.createElement(Render.TouchableOpacity, { onPress: events.onPress, style: wrapperStyle }, renderedImage)),
        !events.onPress && (react_1.default.createElement(Render.View, { style: wrapperStyle }, renderedImage))));
};
exports.default = ImageRenderer;
